import { Injectable } from '@angular/core';
import { HttpService } from '../../../auxiliares/http.service';
import {
  IAPIkey,
  ICreateAPIkey,
  IGetApiKey,
  IListado,
  IQueryParam,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class apiKeyService {
  constructor(private http: HttpService) {}

  public listar(queryParams?: IQueryParam): Observable<IListado<IGetApiKey>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/apikey`, { params });
  }

  public crear(dato: ICreateAPIkey): Observable<IAPIkey> {
    return this.http.post(`${api}/apikey`, dato);
  }

  public listarPorName(name: string): Observable<IGetApiKey> {
    return this.http.get(`${api}/apikey/${name}`);
  }

  public listarPorId(id: string): Observable<IGetApiKey> {
    return this.http.get(`${api}/apikey/${id}`);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/apikey/${id}`);
  }
}
